export type AnkhCommandCategory = string;

export type AnkhProviderReference = `./${string}`;

export type AnkhCapabilityId = `${string}.${string}`;

export interface AnkhCommandDescriptor {
  /**
   * Command path relative to the provider category.
   *
   * An empty path declares the command at the category root.
   */
  readonly path: readonly string[];
  readonly summary: string;
  readonly capability: AnkhCapabilityId;
  readonly aliases?: readonly string[];
  readonly examples?: readonly string[];
}

export interface AnkhCommandProviderManifest {
  readonly id: string;
  readonly category: AnkhCommandCategory;
  readonly version: string;
  readonly capabilities: readonly AnkhCapabilityId[];
  readonly commands: readonly AnkhCommandDescriptor[];
}

export interface AnkhStructureRootMetadata {
  readonly source: string;
  readonly export: string;
}

export interface AnkhStructureMetadata {
  readonly output: string;
  readonly roots: Readonly<Record<string, AnkhStructureRootMetadata>>;
}

export interface AnkhPackageMetadata {
  readonly category: AnkhCommandCategory;
  readonly provider: AnkhProviderReference | null;
  readonly capabilities: readonly AnkhCapabilityId[];
  readonly structure?: AnkhStructureMetadata;
}
